import React from 'react';
import { getConfiguration } from '../../../data/utils/configuration';
import { getCurrencyValue } from '../../../data/utils/getCurrencyValue';

function FlashbetTicketTuples(props) {
	
	const ticketData = props.ticketData;
	const conf = getConfiguration();
	// const frontendType = props.frontendType;
	// const aamsEnviroment = props.aamsEnviroment;
	// const user = props.user;
	const tuples = ticketData.tuples;
	return <>
		<h2 className="h5 text-align-center">RIEPILOGO COMBINAZIONI</h2>
		<div className="container border-2px">
		    {
		    	tuples.map(function(tupla){
		    		const totalAmountTupla = tupla.combs * tupla.amount;
		    		const reactKey = 'system-tupla-' + tupla.id;
		    		return (
			    		<div className={"border-bottom"} key={reactKey}>	
			    			<div  className="d-flex justify-content-space-between bold">
			    		        <span>{tupla.combs}</span>
			    		        <span>{tupla.id + "-pla"} </span>
			    		        <span>IMPORTO {getCurrencyValue(tupla.amount, conf.cs.m, conf.cs.nd, conf.cs.ct)}</span>
			    		        <span>TOTALE: {getCurrencyValue(totalAmountTupla, conf.cs.m, conf.cs.nd, conf.cs.ct)}</span>
			    		    </div>
			    		    <div className="d-flex justify-content-space-between">
			    		        <span>VINCITA MINIMA: {getCurrencyValue(tupla.vMin, conf.cs.m, conf.cs.nd, conf.cs.ct)}</span>
			    		        <span>VINCITA MASSIMA: {getCurrencyValue(tupla.vMax, conf.cs.m, conf.cs.nd, conf.cs.ct)}</span>
			    		    </div>
			    		</div>
		    		)
		    	})
		    }
		</div>
	</>
}

export default FlashbetTicketTuples;